// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Z3Th","textarea":"styles_textarea__1g93F"};